'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _sprocket_white = require('bender-url!./sprocket_white.svg');

var _sprocket_white2 = _interopRequireDefault(_sprocket_white);

var _sprocket_orange = require('bender-url!./sprocket_orange.svg');

var _sprocket_orange2 = _interopRequireDefault(_sprocket_orange);

var _toolsmenu = require('bender-url!../css/toolsmenu.css');

var _toolsmenu2 = _interopRequireDefault(_toolsmenu);

var _url = require('./utils/url');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SprocketMenu = function () {
  function SprocketMenu(options) {
    _classCallCheck(this, SprocketMenu);

    this.baseUrl = this.getHsBaseUrl(options.app_hs_base_url);
    this.cpBaseUrl = this.getHsBaseUrl(options.cp_hs_base_url);
    this.contentId = options.dynamic_page_id && options.dynamic_page_id !== '0' && options.dynamic_page_id !== 'null' ? options.dynamic_page_id : options.page_id;
    this.categoryId = options.category_id;
    this.contentGroupId = options.content_group_id;
    this.portalId = options.portal_id;
    this.cmsEnvironment = this.getCmsEnvironmentFromCookie();
    this.permissionObj = {};
  }

  _createClass(SprocketMenu, [{
    key: 'getHsBaseUrl',
    value: function getHsBaseUrl(baseUrl) {
      return window.localStorage.getItem('HS_LOCAL_TESTING') ? baseUrl.replace(/[^/](\w+?)(?=\.)/, 'local') : baseUrl;
    }
  }, {
    key: 'createElementFromHTML',
    value: function createElementFromHTML(htmlString) {
      var div = document.createElement('div');
      div.innerHTML = htmlString.trim();

      return div.firstChild;
    }
  }, {
    key: 'jsonp',
    value: function jsonp(url, callback) {
      window.jsonpHandler = function (data) {
        callback(data);
      };

      var src = '' + url + (url.indexOf('?') !== -1 ? '&' : '?') + 'callback=jsonpHandler';
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = src;
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }, {
    key: 'httpGet',
    value: function httpGet(url, callback) {
      var request = new XMLHttpRequest();
      request.withCredentials = true;
      request.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          callback(JSON.parse(this.responseText));
        }
      };

      request.open('GET', url, true);
      request.send();
    }
  }, {
    key: 'showToolsMenuIfAuthor',
    value: function showToolsMenuIfAuthor() {
      var _this = this;

      // never show the tools menu in an iframe.
      if (window.location !== window.parent.location) {
        return;
      }

      var resourceName = void 0;
      var resourceId = this.contentId;
      var canPrefetchEditorForResource = false;

      if (this.contentId && this.contentGroupId) {
        if (this.categoryId === 6) {
          resourceName = 'knowledge-articles';
        } else {
          resourceName = 'blog-posts';
        }
      } else if (this.contentGroupId) {
        if (this.categoryId === 6) {
          resourceName = 'knowledge-bases';
        } else {
          resourceName = 'blogs';
        }

        resourceId = this.contentGroupId;
      } else if (this.categoryId === 1 && window.location.pathname.endsWith('_hcms/mem/login')) {
        resourceName = 'content-membership';
      } else {
        canPrefetchEditorForResource = true;
        resourceName = 'landing-pages';
      }

      var hasPermissionUrl = this.baseUrl + '/content-tools-menu/api/v1/tools-menu/has-permission?portalId=' + this.portalId;

      this.jsonp(hasPermissionUrl, function (data) {
        if (data.has_permission) {
          var permissionsUrl = _this.cpBaseUrl + '/content-tools-menu/api/v1/tools-menu/permissions?portalId=' + _this.portalId;
          _this.httpGet(permissionsUrl, function (response) {
            _this.permissionObj = response;

            if (resourceName === 'content-membership') {
              _this.getContentMembershipCookie(resourceName, _this.portalId);
            } else {
              _this.getAppLinks(resourceName, resourceId, _this.portalId);
            }
            if (canPrefetchEditorForResource) {
              _this.setupDeferredPrefetchingOfEditorAssets(resourceName);
            }
          });
        }
      });
    }
  }, {
    key: 'getContentMembershipCookie',
    value: function getContentMembershipCookie(resourceName, portalId) {
      var _this2 = this;

      this.jsonp(this.baseUrl + '/content-tools-menu/api/v1/content/validate-hubspot-user?redirect_url=' + window.location.href + '&portalId=' + portalId, function (data) {
        if (data && data.verified) {
          var redirectUrl = _this2.getUrlParameter('redirect_url');
          window.location.href = redirectUrl === '' ? window.location.origin : redirectUrl;
        }
      });
    }
  }, {
    key: 'getAppLinks',
    value: function getAppLinks(resourceName, pk, portalId) {
      var _this3 = this;

      this.jsonp(this.baseUrl + '/content-tools-menu/api/v1/tools-menu/' + resourceName + '/' + pk + '/actions?portalId=' + portalId, function (data) {
        if (data.actions && data.strings) {
          _this3.showAppLinks(data.actions, data.strings);
        }
      });
    }
  }, {
    key: 'showAppLinks',
    value: function showAppLinks(actions, strings) {
      // Insert site maps link if there is a site map on the page
      var mapWidgets = [].slice.call(document.querySelectorAll('[data-menu-id]')).filter(function (element) {
        return !!element.getAttribute('data-menu-id').trim();
      });

      var mapWidget = mapWidgets.length > 0 ? mapWidgets[0] : null;
      if (mapWidget !== null) {
        var dataMenuId = mapWidget.getAttribute('data-menu-id').trim();
        actions.push([strings.EDIT_NAVIGATION_MENU, this.baseUrl + '/settings/' + this.portalId + '/website/navigation/' + dataMenuId]);
      }

      var links = '';
      actions.forEach(function (link) {
        var linkText = link[0];
        var linkUrl = link[1];
        var linkUrlWithTracking = linkUrl + (0, _url.getUsageTrackingParam)(linkUrl);
        links += '        <li><a target=\'_blank\' href=\'' + linkUrlWithTracking + '\'>\n        ' + linkText + '\n        </a></li>      ';
      });

      if (this.permissionObj.permissions.includes('CAN_PREVIEW_ENVIRONMENTS')) {
        links += '        <li><a class="hs-environment-buffer-on">' + strings.VIEW_BUFFER + '</a></li>        <li><a class="hs-environment-buffer-off">' + strings.VIEW_HARD + '</a></li>      ';
      }

      var css = '<link rel="stylesheet" href="' + _toolsmenu2.default + '" />';

      var menu = '\n      <div role="button" class="hs-tools-menu hs-collapsed" aria-expanded="false">\n        <img class="hs-sprocket" alt="' + strings.MENU_ICON_ALT_TEXT + '" src="' + _sprocket_white2.default + '" />\n        <div class="hs-dropdown">\n          <div class="hs-title">' + strings.MENU_TITLE + '</div>\n          <ul>\n            ' + links + '\n            <li>\n              <a role="button" href="#hide-menu" class="hs-menu-hider">' + strings.HIDE_THIS_MENU + '</a>\n            </li>\n          </ul>\n        </div>\n      </div>\n    ';

      document.body.appendChild(this.createElementFromHTML(css));
      document.body.appendChild(this.createElementFromHTML(menu));
      this.registerEvents();
    }
  }, {
    key: 'registerEvents',
    value: function registerEvents() {
      var _this4 = this;

      var element = document.querySelector('.hs-tools-menu');
      this.registerDropdown(element);

      element.querySelector('.hs-menu-hider').addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        element.style.display = 'none';
      });

      var bufferOn = element.querySelector('.hs-environment-buffer-on');

      if (bufferOn) {
        if (!this.cmsEnvironment.buffer) {
          bufferOn.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            _this4.requestAndSetEnvironmentCookie(_this4.portalId, true);
          });
        } else {
          bufferOn.parentElement.removeChild(bufferOn);
        }
      }

      var bufferOff = element.querySelector('.hs-environment-buffer-off');

      if (bufferOff) {
        if (this.cmsEnvironment.buffer) {
          bufferOff.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            _this4.requestAndSetEnvironmentCookie(_this4.portalId, false);
          });
        } else {
          bufferOff.parentElement.removeChild(bufferOff);
        }
      }
    }
  }, {
    key: 'requestAndSetEnvironmentCookie',
    value: function requestAndSetEnvironmentCookie(portalId, buffer) {
      var cookieUrl = this.cpBaseUrl + '/content-tools-menu/api/v1/tools-menu/environment-cookie?portalId=' + portalId + '&environmentId=1&buffer=' + buffer;
      this.httpGet(cookieUrl, function (data) {
        document.cookie = 'hs_cms_environment=' + btoa(JSON.stringify(data));
        window.location.reload();
      });
    }
  }, {
    key: 'registerDropdown',
    value: function registerDropdown(element) {
      var menuIconElement = Array.from(element.children).find(function (child) {
        return child.classList.contains('hs-sprocket');
      });
      var hideDropdown = function hideDropdown() {
        element.classList.add('hs-collapsed');
        element.setAttribute('aria-expanded', false);
        menuIconElement.setAttribute('src', _sprocket_white2.default);
      };
      var showDropdown = function showDropdown() {
        element.classList.remove('hs-collapsed');
        element.setAttribute('aria-expanded', true);
        menuIconElement.setAttribute('src', _sprocket_orange2.default);
      };

      var bodyClickHandler = function bodyClickHandler() {
        hideDropdown();
        document.body.removeEventListener('click', bodyClickHandler);
      };

      var menuClickHandler = function menuClickHandler(event) {
        if (event.target.getAttribute('href')) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();

        if (element.classList.contains('hs-collapsed')) {
          showDropdown();
          document.body.addEventListener('click', bodyClickHandler);
        } else {
          hideDropdown();
          document.body.removeEventListener('click', bodyClickHandler);
        }
      };
      element.addEventListener('click', menuClickHandler, false);
    }
  }, {
    key: 'getUrlParameter',
    value: function getUrlParameter(name) {
      name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
  }, {
    key: 'getCmsEnvironmentFromCookie',
    value: function getCmsEnvironmentFromCookie() {
      var cookieStr = this.getCookie('hs_cms_environment');

      if (cookieStr) {
        return JSON.parse(atob(cookieStr));
      } else {
        return {
          portalId: 0,
          env: 1,
          buffer: false,
          createdAt: 0
        };
      }
    }
  }, {
    key: 'getCookie',
    value: function getCookie(cookieName) {
      var name = cookieName + '=';
      var cookieArr = document.cookie.split(';');
      for (var i = 0; i < cookieArr.length; i++) {
        var c = cookieArr[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }

    // Two seconds after window load, fetch a small script that in turn, appends
    // abunch of <link rel="prefetch"> tags to the page. The idea is to use the
    // idle time of the users page load to get a jump start on loading the heavy
    // assets of the editor. The prefetches are given the lowest priority by the
    // browser, so it hopefully doesn't interfere with the users page.
    // See https://developer.mozilla.org/en-US/docs/Web/HTTP/Link_prefetching_FAQ

  }, {
    key: 'setupDeferredPrefetchingOfEditorAssets',
    value: function setupDeferredPrefetchingOfEditorAssets(resourceName) {
      window.addEventListener('load', function () {
        setTimeout(function () {
          var prefetcherPath = void 0;
          if (resourceName === 'landing-pages') {
            prefetcherPath = 'content/editor/prefetcher.js';
          } else {
            return;
          }
          // Doing this to avoid relative domains, don't want to get 404s
          // when developing locally
          var domain = window.location.host.indexOf('hubspotqa') > -1 ? 'app.hubspotqa.com' : 'app.hubspot.com';

          var script = document.createElement('script');
          script.src = 'https://' + domain + '/' + prefetcherPath;
          document.head.appendChild(script);
        }, 2000);
      });
    }
  }]);

  return SprocketMenu;
}();

exports.default = SprocketMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/SprocketMenu.js
// module id = 2
// module chunks = 0 1